// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,body{color:#000000;font:13pt/17pt Staff, Arial, \"PT Sans\", sans-serif}h1{font-size:18pt;font-weight:bold;line-height:22pt}h2{font-size:14pt;font-weight:bold;line-height:18pt}h3{font-size:14pt;font-weight:normal;line-height:18pt}a{color:#0f995d}\n", ""]);
// Exports
module.exports = exports;
